module.exports = __webpack_public_path__ + "static/insta-0245cc677b866c4fe52edf427a694692.png";